<div class="small_size">
  <div class="text-center" *ngIf="rest.local_preferences.default_ticket_image_id">
  	<img [src]="rest.getImagePath(rest.local_preferences.default_ticket_image_id)" class="image_logo_ticket">
  </div>
  <div class="d-print-none text-center">
  	<button type="button" class="btn btn-primary m-3" (click)="justPrint()">Imprimir</button>
  	<button type="button" class="btn btn-primary m-3" style="" (click)="location.back()">Regresar</button>
  </div>
  <div *ngIf="payment_info_list.length">
	<div *ngIf="payment_info.payment.paid_by_user_id">
		Cliente: <b>{{payment_info.paid_by_user?.name || order_info.client?.name | titlecase}}</b>
	</div>
  	<div>
  		Le atendio: <b>{{payment_info.created_by_user?.name | titlecase}}</b>
  	</div>
  	<div>
  		Fecha: <b>{{payment_info.payment.created | shortDate}}</b>
  	</div>

  	<!--table class="w-100">
  		<tr>
  			<th class="text-end">Folio</th>
  			<td class="text-end">{{order_info.order.store_consecutive}}</td>
  		</tr>
  		<tr>
  			<th class="text-end">Subtotal</th>
  			<td class="text-end">{{order_info.order.total |currency}}</td>
  		</tr>
  		<tr>
  			<th class="text-end">Descuento</th>
  			<td class="text-end">{{order_info.order.discount |currency}}</td>
  		</tr>
  		<tr>
  			<th class="text-end">Total</th>
  			<td class="text-end">{{(order_info.order.total-order_info.order.discount) |currency}}</td>
  		</tr>
  	</table-->

  	<h1 class="text-center">ABONOS</h1>
  	<table class="w-100">
  		<tr class="fw-bold">
			<td class="text-end">Orden</td>
			<td class="text-end">Pago</td>
			<td class="text-end" *ngIf="this.show_actions_column">Acciones</td>
			<td class="text-end">Por Saldar</td>
  			<td class="text-end">Fecha</td>
  			<td class="text-end">Abono</td>
			<td class="text-end">Tipo P.</td>
  			<td class="text-end">Balance</td>
  		</tr>
  		<ng-container *ngFor="let bmo of sums">
  			<tr>
  				<td class="text-end">#{{bmo.order_info.order.id}}</td>
  				<td class="text-end">#{{bmo.payment_info.payment.id}}</td>
				<td class="text-end" *ngIf="bmo.order_info.order.sat_factura_id && !bmo.payment_info.payment.sat_factura_id">
					<button type="button" class="btn btn-primary w-10 m-1" title="Facturar Pago" (click)="showFacturarPago(bmo.payment_info)">
						<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-receipt-cutoff" viewBox="0 0 16 16">
							<path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"/>
							<path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118z"/>
						</svg>
					</button>
				</td>
  				<td class="text-end">{{bmo.prev_balance | currency}} {{bmo.order_info.order.currency_id}} </td>
  				<td class="text-end">{{bmo.created | shortDate:'full' }}</td>
  				<td class="text-end">${{bmo.currency_amount | number:'1.2-2'}} {{bmo.currency_id}}</td>
				<td class="text-end">{{legend[bmo.payment_type + '-' + bmo.currency_id]}}</td>
				<td class="text-end">{{bmo.balance | currency }} {{bmo.order_info.order.currency_id}}</td>
  			</tr>
  		</ng-container>
  	</table>

  	<table class="w-100">
  		<ng-container	*ngIf="payment_info">
  			<tr class="border-top">
  				<td class="text-end">Total Abonado</td>
  				<td class="text-end">{{payment_info.payment.payment_amount | currency:'$'}}</td>
  			</tr>
  			<tr class="border-top">
  				<td class="text-end larger fw-bold">Total Recibido</td>
  				<td class="text-end larger fw-bold">{{payment_info.payment.received_amount | currency:'$'}}</td>
  			</tr>
  			<tr class="mx-0">
  				<td class="text-end fw-bold">Cambio</td>
  				<td class="text-end fw-bold">{{payment_info.payment.change_amount | currency:'$'}}</td>
  			</tr>
  			<tr class="border-top">
  				<td class="text-end">Pendiente</td>
  				<td class="text-end">{{orders_total - all_partial_payments | currency:'$'}}</td>
  			</tr>
  		</ng-container>
  	</table>
  </div>
</div>

<app-modal [(show)]="show_facturar_pago">
	<div class="container-fluid">
		<h2>Facturar el pago</h2>
		<app-loading [is_loading]="is_loading"></app-loading>
		<form name="facturar_tfp" (submit)="facturarElPago($event)" ngNativeValidate>
			<div class="row">
				<div class="col-12">
					<label>Fecha de pago</label>
					<input type="datetime-local" class="form-control" name="fecha_pago" [(ngModel)]="fecha_pago" required>
				</div>
				<div class="col-12">
					<label>Serie</label>
					<input type="text" class="form-control" name="sat_serie" [(ngModel)]="sat_serie" minlength="1" maxlength="25" required>
				</div>
				<div class="col-12">
					<label>Correo Electrónico</label>
					<input type="email" name="pago_factura_email" [(ngModel)]="pago_factura_email" class="form-control" required>
				</div>
			</div>
			<div class="row py-3">
				<div class="col-6">
					<button type="button" class="btn btn-primary w-100" (click)="show_facturar_pago=false" [disabled]="is_loading">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Facturar Pago</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>
